import EpcrTreatment from "./EpcrTreatment"
import EpcrMedication from "./medication/EpcrMedication"

const EpcrLegacyTreatment = ({ ...props }) => {
    return <>
            <EpcrMedication {...props}></EpcrMedication>
            <EpcrTreatment {...props}></EpcrTreatment>
    </>
}
export default EpcrLegacyTreatment;